import { createContext, ReactElement, useContext, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import React from 'react';

const RouterContext = createContext<IRouter>({ route: {} });

interface IRouter {
  route: {
    from?: string;
    to?: string;
  };
}

export const RouterProvider = ({ children }: { children: ReactElement<any, any> }) => {
  const location = useLocation();
  const [route, setRoute] = useState<{ to?: string; from?: string }>({
    to: location.pathname,
    from: undefined,
  });

  useEffect(() => {
    setRoute((prev) => ({ to: location.pathname, from: prev.to }));
  }, [location]);

  return <RouterContext.Provider value={{ route }}>{children}</RouterContext.Provider>;
};

export const useRouter = () => {
  return useContext(RouterContext);
};
